import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router'
import { Dropdown, MenuItem } from 'react-bootstrap'

import Logo from 'assets/images/logo-gc.png'

import Styles from './index.scss'

// page-sidebar-closed

const Header = props => (
  <div className="page-header navbar navbar-fixed-top">
    <div className="page-header-inner ">
      <div className="page-logo" style={{ paddingRight: '0px' }}>
        <Link to="/">
          <img
            src={Logo}
            style={{ width: '40px', margin: '5px' }}
            className="logo-default"
            alt=""
          />
        </Link>
        <button
          className={`menu-toggler sidebar-toggler ${Styles.button}`}
          onClick={() => props.handleSidebar(props.sidebarData)}
        >
          <span />
        </button>
      </div>
      <div className="mobile-menu visible-sm visible-xs">
        <div className="nav navbar-nav pull-right">
          <Dropdown id="bg-nested-dropdown" className="dropdown-user">
            <Dropdown.Toggle noCaret>
              <i className="icon-user" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-default">
              <MenuItem href="#">
                Account
              </MenuItem>
              <MenuItem href="#">
                Peers
              </MenuItem>
              <MenuItem href="#">
                Settings
              </MenuItem>
              <MenuItem divider />
              <MenuItem href="/logout">
                Signout
              </MenuItem>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="hidden-sm hidden-xs top-menu">
        <div className="nav navbar-nav pull-right">
          <Dropdown id="bg-nested-dropdown" className="dropdown-user">
            <Dropdown.Toggle noCaret>
              <i className="icon-user" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-default">
              <MenuItem href="#">
                Account
              </MenuItem>
              <MenuItem href="#">
                Peers
              </MenuItem>
              <MenuItem href="#">
                Settings
              </MenuItem>
              <MenuItem divider />
              <MenuItem href="/logout">
                Signout
              </MenuItem>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  </div>
)

Header.defaultProps = {
  sidebarData: {
    ulClass: '',
  },
}

Header.propTypes = {
  sidebarData: PropTypes.shape({
    ulClass: PropTypes.string.isRequired,
  }).isRequired,
  handleSidebar: PropTypes.func.isRequired,
}

export default Header
